// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  grid-column-start: 1;
  grid-column-end: -1;
}
.wrapper :global .iconList {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}
.wrapper :global .iconList i {
  font-size: 22px !important;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
}
.wrapper :global .textList h1 {
  font-size: 20px;
  color: #697578;
}
.wrapper :global .textList h2 {
  font-size: 14px;
  color: #697578;
}
.wrapper :global .textList p {
  font-size: 15px;
}
.wrapper :global .textList p.alert {
  font-size: 15px;
  font-weight: 400;
  color: #CC0101;
  padding: 0px;
}
.wrapper :global a {
  color: #C4408F;
}
.contentColumnRow {
  width: 100%;
}
.contentColumn {
  cursor: pointer;
  padding: 3px;
  display: inline;
  color: gray;
  margin-right: 10px;
}
.contentColumn i {
  margin-right: 5px;
}
.contentColumn :global .faiconpicture {
  margin-right: 5px;
  position: relative;
  top: 6px;
}
.contentColumn :global .faiconpicture i {
  margin-right: 0px !important;
}
.contentColumnEllipse {
  display: inline;
  color: gray;
  margin-right: 10px;
}
.contentColumnEllipse i {
  margin-right: 5px;
}
.overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  float: left;
  width: 90%;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/DataCardContentRow.less"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,mBAAA;AADF;AADA;EAMM,aAAA;EAEA,eAAA;EAEA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AAJN;AATA;EAgBQ,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJR;AAhBA;EA2BQ,eAAA;EACA,cAAA;AARR;AApBA;EAgCQ,eAAA;EACA,cAAA;AATR;AAxBA;EAqCQ,eAAA;AAVR;AA3BA;EAyCQ,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAXR;AAjCA;EAiDM,cAAA;AAbN;AAmBA;EACE,WAAA;AAjBF;AAoBA;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EAEA,kBAAA;AAnBF;AAaA;EAQI,iBAAA;AAlBJ;AAUA;EAgBM,iBAAA;EACA,kBAAA;EACA,QAAA;AAvBN;AAKA;EAcQ,4BAAA;AAhBR;AAyBA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AAvBF;AAoBA;EAKI,iBAAA;AAtBJ;AA0BA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;EACA,UAAA;AAxBF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.wrapper {\n  grid-column-start: 1;\n  grid-column-end: -1;\n\n  :global {\n    .iconList {\n      display: flex;\n      // flex-direction: column;\n      flex-wrap: wrap;\n      // justify-content: center;\n      align-items: flex-start;\n      width: 100%;\n      padding-top: 10px;\n      padding-bottom: 10px;\n\n      i {\n        font-size: 22px !important;\n        padding-left: 5px;\n        padding-right: 5px;\n        padding-top: 2px;\n        padding-bottom: 2px;\n      }\n    }\n\n    .textList {\n\n      h1 {\n        font-size: 20px;\n        color: @text-gray2;\n      }\n\n      h2 {\n        font-size: 14px;\n        color: @text-gray2;\n      }\n\n      p {\n        font-size: 15px;\n      }\n\n      p.alert {\n        font-size: 15px;\n        font-weight: 400;\n        color: @error-color;\n        padding: 0px;\n      }\n    }\n\n    a {\n      color: @menu-primary\n    }\n  }\n\n}\n\n.contentColumnRow {\n  width: 100%;\n}\n\n.contentColumn {\n  cursor: pointer;\n  padding: 3px;\n  display: inline;\n  color: gray;\n  // width: max-content;\n  margin-right: 10px;\n  i {\n    margin-right: 5px;\n  }\n\n  :global {\n    .faiconpicture {\n      i {\n        margin-right: 0px !important;\n      }\n      margin-right: 5px;\n      position: relative;\n      top: 6px;\n    }\n  }\n}\n\n.contentColumnEllipse {\n  display: inline;\n  color: gray;\n  margin-right: 10px;\n  i {\n    margin-right: 5px;\n  }\n}\n\n.overflow {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  pointer-events:none;\n  float: left;\n  width: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
